import {writable} from 'svelte/store';
import {I_COMPANY} from "../../../../../lib/datatypes";
import {sortCompareASC} from "../../../../../lib/utils";

export const companies = writable({
    list: [],
    lookup: {},
});
export const companies_fetching = writable(false);

const _createLookup = list => {
    let result = {};
    for(let i = 0, n = list.length; i < n; i++) {
        result[list[i][I_COMPANY.ID]] = list[i];
    }
    return result;
};


const _updateStructures = companies => {
    companies.list.sort((a, b) => sortCompareASC(a[I_COMPANY.NAME].toLowerCase(), b[I_COMPANY.NAME].toLowerCase()));
    companies.lookup = _createLookup(companies.list);
};

let $companies = null;
const unsubscribe = companies.subscribe(val => $companies = val);

// Explicitly set the contents of companies by passing them in, ie from bootstrapped data
export const setCompanies = companies_data => {
    companies.update(companies => {
        companies.list = companies_data;
        _updateStructures(companies);
        return companies;
    });
};

export const loadCompanies = async () => {
    companies_fetching.set(true);

    const response = await fetch(`/api/companies`);
    let result = await response.json();
    companies_fetching.set(false);
    companies.update(companies => {
        companies.list = result;
        _updateStructures(companies);
        return companies;
    });
};

export const addRawCompany = async (arr) => {
    companies_fetching.set(true);

    const url = `/api/company/add`;
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(arr)
    });
    let result = await response.json();
    companies_fetching.set(false);
    companies.update(companies => {
        companies.list.push(result);
        _updateStructures(companies);
        return companies;
    });
    return result;
};

export const updateRawCompany = async company => {
    companies_fetching.set(true);

    const url = `/api/company/${company[I_COMPANY.ID]}/update`;
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(company)
    });
    let result = await response.json();
    // console.log(response, result);
    // ..update local copy of companies with the updated data - could just download the data again (server would have updated data), but..
    const i = $companies.list.findIndex(el => el[I_COMPANY.ID] === company[I_COMPANY.ID]);
    companies_fetching.set(false);
    companies.update(companies => {
        companies.list[i] = result;  // @ASSUMPTION that the result will always contain a 'person', ie doesn't handle errors
        _updateStructures(companies);
        return companies;
    });
    return result;
};